﻿//import Map from 'ol/Map.js';
import View from 'ol/View.js';
import TileLayer from 'ol/layer/Tile.js';
import ImageLayer from 'ol/layer/Image.js';
import VectorLayer from 'ol/layer/Vector';
import ImageWMS from 'ol/source/ImageWMS.js';
import IIIFInfo from 'ol/format/IIIFInfo.js';
import IIIF from 'ol/source/IIIF.js';


import { getJsonSourceFiltered, getIconStyle } from './vxLayerLibrary';

let param;
let vxOlMap;
let layers;
let vdaPyrTiff
class vxOlGigapan {

    static getGigapanLayers(initparam, myVxOlMap) {
        param = initparam;
        vxOlMap = myVxOlMap
        // todo: filter by image
        const vdaGigaPanPoint = new VectorLayer({
            title: 'Point of Interest',
            source: getJsonSourceFiltered('vx3dproject:v_pt_gigapan_poi_ph', `&cql_filter=image_filename='${param.image}'`),
            //style: getCircleStyle(10, 'blue'),
            style: getIconStyle('/images/img-markers/peak.png',25),
            name: 'pt_gigapan_poi'
        });

        const vdaGigaPanLine = new ImageLayer({
            //extent: [-13884991, 2870341, -7455066, 6338219],
            title: 'Geology - Lines',
            source: new ImageWMS({
                url: `/geoserver/wms`,
                //url: `/geoserver/wms`,
                params: { 'LAYERS': 'vx3dproject:v_pl_geo_gigapan', 'cql_filter': `image_filename = '${param.image}'` },
                ratio: 1,
                serverType: 'geoserver',
            }),
        });

        const vdaGigaPanPoly = new ImageLayer({
            title: 'Geology - Polygons',
            //extent: [-13884991, 2870341, -7455066, 6338219],
            source: new ImageWMS({
                url: `/geoserver/wms`,
                //url: `/geoserver/wms`,
                params: { 'LAYERS': 'vx3dproject:v_pg_geo_gigapan', 'cql_filter': `image_filename = '${param.image}'` },
                ratio: 1,
                serverType: 'geoserver',
            }),
            visible: false,
        });

        vdaPyrTiff = new TileLayer(),
            layers = [vdaPyrTiff, vdaGigaPanPoly, vdaGigaPanLine, vdaGigaPanPoint];

        return layers;
    }
    static async refreshMap(notifyDiv) {
        let imageInfoUrl = `/iiif/${param.image}.tif/info.json`;
        try {
            let response = await fetch(imageInfoUrl);
            try {
                let imageInfo = await response.json();

                const options = new IIIFInfo(imageInfo).getTileSourceOptions();
                if (options === undefined || options.version === undefined) {
                    notifyDiv.textContent =
                        'Data seems to be no valid IIIF image information.';
                    return;
                }
                options.zDirection = -1;
                const iiifTileSource = new IIIF(options);
                vdaPyrTiff.setSource(iiifTileSource);
                vxOlMap.map.setView(
                    new View({
                        resolutions: iiifTileSource.getTileGrid().getResolutions(),
                        extent: iiifTileSource.getTileGrid().getExtent(),
                        constrainOnlyCenter: true,
                        enableRotation: false
                    }),
                );
                vxOlMap.map.getView().fit(iiifTileSource.getTileGrid().getExtent());
                console.log(JSON.stringify(iiifTileSource.getTileGrid().getExtent()));
                notifyDiv.textContent = '';
                return true;
            }
            catch (error) {
                console.log(JSON.stringify(error));
                notifyDiv.textContent = 'Could not read image info json. ' + error;
                return false;
            };
        }
        catch (error) {
            console.log(JSON.stringify(error));
            notifyDiv.textContent = 'Could not read data from URL.';
            return false;

        };
    }
    static getSelectionOverlay(feature, layername) {
        var props = feature.getProperties();
        const div = document.createElement('div');
        div.className = 'immagine-item';

        const title = document.createElement('h5');
        const img = document.createElement('img');
        const link = document.createElement('a');

        //todo: preview of map?
        let my_x = (parseFloat(props.x_gp)) - 1024;
        let my_y = (0 - parseFloat(props.y_gp)) - 512;
        img.src = `/iiif/${props.image_filename}.tif/${my_x},${my_y},2048,1024/256,128/0/default.jpg`;
        img.alt = props.name;

        link.href = `/ol/${layername}/${props.id}`;
        //link.title = props.name;
        link.title = `View on map`;
        //link.textContent = `View on map`;
        link.appendChild(img);
        link.target = '_self';

        title.textContent = props.name;
        div.appendChild(title);

        div.appendChild(link);
        return div;

    }
}

export default vxOlGigapan;